import { CircularProgress, Typography } from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import { Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import Input from "../../Input/Input";
import Icon from "../../Icon/Icon";
import {
  RiFacebookCircleFill,
  RiInstagramFill,
  RiLinkedinBoxFill
} from "react-icons/ri";
import { insert } from "../../../services/subscriptionService";
import Iubenda from "react-iubenda-policy";
import LinkButton from "../../LinkButton/LinkButton";
import { ROUTES } from "../../../config/site.config";


const links = [{
        label: "FurciFood",
        path: ROUTES.FURCIFOOD_PATH,
    },
    {
        label: "Furcy",
        path: ROUTES.FURCY_PATH,
    },
    {
        label: "FurciNet",
        path: ROUTES.FURCINET_PATH
    },
    {
        label: "Furciner",
        path: ROUTES.FURCINER_PATH,
    },
];

const Footer = (props) => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "100%",
      height: "auto",
      paddingTop: "10vh",
      paddingBottom: "10vh",
      backgroundColor: "#121921",
    },
    interactionContainer: {
      position: "relative",
      width: "85%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
    linksContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      justifyContent: "space-between",
      flexWrap: "wrap",
    },
    link: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      margin: 10,
    },
    keepInTouchContainer: {
      width: "40%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
    },
  };

  const [_subscribing, setSubscribing] = useState(false);
  const [subscriberEmail, setSubscriberEmail] = useState(null);
  const subscriberEmailRef = useRef();

  const searchOnKeyEnterPressed = (event) => {
    if (event.key === "Enter") {
      subscriberEmailRef.current.blur();
      handleSubscribeToNews();
    }
  };

  const handleSubscribeToNews = () => {
    if (subscriberEmail != null && _subscribing === false) {
      setSubscribing(true);
      insert({ email: subscriberEmail })
        .then((x) => setSubscribing("SUCCESS"))
        .catch((err) => setSubscribing("ERROR"));
    }
  };

  useEffect(() => {
    if (_subscribing === "ERROR" || _subscribing === "SUCCESS") {
      setSubscribing(false);
    }
  }, [subscriberEmail]);

  return (
    <div style={{ ...styles.container, ...props.style }}>
      <div style={styles.interactionContainer}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={3} style={{ marginTop: 20 }}>
            <Typography variant="h6" style={{ color: "white" }}>
              FOOD-SPACE
            </Typography>

            {links.map((item, key) => (
              <Link
                key={key}
                to={item.path}
                style={{
                  textEmphasis: "none",
                  textDecoration: "none",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    color: "white",
                    opacity: 0.7,
                    cursor: "pointer",
                    marginTop: 5,
                  }}
                >
                  {item.label}
                </Typography>
              </Link>
            ))}
          </Grid>

          <Grid item xs={12} md={3} style={{ marginTop: 20 }}>
            <Typography variant="h6" style={{ color: "white" }}>
              REGOLAMENTO
            </Typography>
            <Link
              key={"terminiECondizioni"}
              to={ROUTES.TERMINI_PATH}
              style={{
                textEmphasis: "none",
                textDecoration: "none",
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
              }}
            >
              <Typography
                variant="h6"
                style={{
                  color: "white",
                  opacity: 0.7,
                  cursor: "pointer",
                  marginTop: 5,
                }}
              >
                Termini & Condizioni
              </Typography>
            </Link>
            <Iubenda id={"32968343"} type="cookie" styling="nostyle">
              <Typography
                variant="h6"
                style={{
                  color: "white",
                  opacity: 0.7,
                  cursor: "pointer",
                  marginTop: 5,
                }}
              >
                Cookie Policy
              </Typography>
            </Iubenda>

            <Iubenda id={"32968343"} type="privacy" styling="nostyle">
              <Typography
                variant="h6"
                style={{
                  color: "white",
                  opacity: 0.7,
                  cursor: "pointer",
                  marginTop: 5,
                }}
              >
                Privacy Policy
              </Typography>
            </Iubenda>

            <Link
              key={"scrivici"}
              to={ROUTES.FAQ_PATH}
              style={{
                textEmphasis: "none",
                textDecoration: "none",
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
              }}
            >
              <Typography
                variant="h6"
                style={{
                  color: "white",
                  opacity: 0.7,
                  cursor: "pointer",
                  marginTop: 5,
                }}
              >
                FAQ
              </Typography>
            </Link>
          </Grid>

          <Grid item xs={12} md={3} style={{ marginTop: 20 }}>
            <Typography variant="h6" style={{ color: "white" }}>
              INFO
            </Typography>
            <Link
              key={"contattaci"}
              to={ROUTES.CONTATTACI_PATH}
              style={{
                textEmphasis: "none",
                textDecoration: "none",
                display: "flex",
                flexDirection: "row",
                alignItems: "baseline",
              }}
            >
              <Typography
                variant="h6"
                style={{
                  color: "white",
                  opacity: 0.7,
                  cursor: "pointer",
                  marginTop: 5,
                }}
              >
                Contattaci
              </Typography>
            </Link>
            <Typography
              variant="h6"
              style={{
                color: "white",
                opacity: 0.7,
                cursor: "pointer",
                marginTop: 5,
              }}
            >
              <a
                style={{
                  color: "white",
                  cursor: "pointer",
                }} 
                href="mailto:info@furcifood.it">info@furcifood.it</a>
            </Typography>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                marginTop: 10,
              }}
            >
              <a
                className="social-icon-link github"
                href="https://www.instagram.com/furcifood/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <RiInstagramFill
                  size={28}
                  color={"white"}
                  style={{ cursor: "pointer", color: "#D3B925" }}
                />
              </a>
              <a
                className="social-icon-link github"
                href="https://www.facebook.com/FurciFood"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <RiFacebookCircleFill
                  size={28}
                  color={"white"}
                  style={{ cursor: "pointer", marginLeft: 5, color: "#D3B925" }}
                />
              </a>
              {/* <a
                className="social-icon-link github"
                href="https://www.google.it"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <RiYoutubeFill
                  size={28}
                  color={"white"}
                  style={{ cursor: "pointer", marginLeft: 5, color: "#D3B925" }}
                />
              </a> */}
              {/* <a
                className="social-icon-link github"
                href="https://www.google.it"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <RiWhatsappFill
                  size={28}
                  color={"white"}
                  style={{ cursor: "pointer", marginLeft: 5, color: "#D3B925" }}
                />
              </a> */}
              <a
                className="social-icon-link linkedin"
                href="https://www.linkedin.com/in/furcifood-l-altro-modo-di-mangiare-7104a1234/"
                target="_blank"
                rel="noreferrer"
                aria-label="Linkedin"
              >
                <RiLinkedinBoxFill
                  size={30}
                  color={"white"}
                  style={{ cursor: "pointer", marginLeft: 5, color: "#D3B925" }}
                />
              </a>
            </div>
          </Grid>

          <Grid item xs={12} md={2} style={{ marginTop: 20, flexGrow: "2" }}>
            <Typography variant="h6" style={{ color: "white" }}>
              RESTA AGGIORNATO
            </Typography>
            <Typography
              variant="body1"
              style={{ color: "white", opacity: 0.7 }}
            >
              Non perderti le nuove adesioni
            </Typography>
            <div
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "rgba(255,255,255,0.05)",
                marginTop: 10,
                width: 260,
              }}
            >
              <Input
                externalRef={subscriberEmailRef}
                placeholder="Inserisci la tua email"
                style={{ textColor: "white" }}
                className="subscribe-input"
                value={subscriberEmail}
                onChangeText={(text) => setSubscriberEmail(text)}
                onKeyPress={searchOnKeyEnterPressed}
              />

              <div
                style={{
                  height: 35,
                  width: 20,
                  backgroundColor: "#D3B925",
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderTopRightRadius: 5,
                  borderBottomRightRadius: 5,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => handleSubscribeToNews()}
              >
                {!_subscribing && (
                  <Icon
                    name="send"
                    style={{
                      heigth: "100%",
                      color: "white",
                      fontSize: 20,
                    }}
                  />
                )}

                {_subscribing && (
                  <CircularProgress
                    style={{ width: 20, height: 20, color: "white" }}
                  />
                )}

                {_subscribing && _subscribing === "ERROR" && (
                  <Icon
                    name="error_outline"
                    style={{
                      heigth: "100%",
                      color: "white",
                      fontSize: 20,
                    }}
                  />
                )}
                {_subscribing && _subscribing === "SUCCESS" && (
                  <Icon
                    name="check_circle"
                    type="outlined"
                    style={{
                      heigth: "100%",
                      color: "white",
                      fontSize: 20,
                    }}
                  />
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                width: 260,
                marginTop: 15,
              }}
            >
              <LinkButton label="Aderisci" to={ROUTES.JOIN_PATH} buttonStyle={{
                  width: 120,
                }} />
              <LinkButton label="Suggerisci" to={ROUTES.SUGGEST_PATH} buttonStyle={{
                  width: 120,
                  marginRight: 0
                }} />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Footer;
